module.exports = __webpack_public_path__ + "static/media/help-icon.a5f3f50d.svg";